import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTAButton } from "@/components/CTAButton";
import FaqAccordion from "@/components/FaqAccordion";
import { BUSINESS } from "@/data/site";

export default function FAQ() {
  return (
    <>
      <SEO title="FAQ" description="Frequently asked questions about Chopstick Chinese Corner — location, reservations, delivery, dietary options and more." />
      <PageHero
        overline="Good to know"
        titleLines={["Your", "questions,", "answered."]}
      />
      <section className="mx-auto max-w-4xl px-5 md:px-8 py-16 md:py-24">
        <Reveal>
          <FaqAccordion />
        </Reveal>
        <Reveal>
          <div className="mt-16 text-center">
            <p className="text-muted-foreground">Still have a question?</p>
            <div className="mt-5 flex flex-wrap justify-center gap-3">
              <CTAButton href={`tel:${BUSINESS.phoneHref}`} variant="primary" icon={false}>Call {BUSINESS.phoneDisplay}</CTAButton>
              <CTAButton to="/contact" variant="ghost">Contact us</CTAButton>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
